// extracted by mini-css-extract-plugin
export default {"myCustomClass1":"followButton_myCustomClass1__5+Rya","followSize":"followButton_followSize__EIPCR"};